(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/lb-ui/better-dialog/assets/javascripts/use-dialog.js') >= 0) return;  svs.modules.push('/components/lb-ui/better-dialog/assets/javascripts/use-dialog.js');
"use strict";

const _svs$components$lbUi$ = svs.components.lbUi.betterDialog,
  BetterDialog = _svs$components$lbUi$.BetterDialog,
  ActualDialog = _svs$components$lbUi$.ActualDialog;
const _React = React,
  useCallback = _React.useCallback,
  useRef = _React.useRef,
  useMemo = _React.useMemo;
const createDialog = (_ref, resolve) => {
  let title = _ref.title,
    declineText = _ref.declineText,
    acceptText = _ref.acceptText,
    messages = _ref.messages,
    showLoader = _ref.showLoader,
    icon = _ref.icon,
    autoCloseOnAccept = _ref.autoCloseOnAccept;
  const dialog = new BetterDialog().setTitle(title);
  messages.forEach(message => {
    dialog.addText(message);
  });
  if (icon) {
    dialog.setIcon(icon);
  }
  if (declineText) {
    dialog.addAction(declineText, dialog => {
      dialog.close();
      resolve(false);
    });
  }
  dialog.addAction(acceptText, dialog => {
    autoCloseOnAccept && dialog.close();
    resolve(true);
  }, showLoader);
  return dialog.compose();
};
const useDialog = function () {
  let _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    title = _ref2.title,
    declineText = _ref2.declineText,
    _ref2$acceptText = _ref2.acceptText,
    acceptText = _ref2$acceptText === void 0 ? 'Fortsätt' : _ref2$acceptText,
    _ref2$messages = _ref2.messages,
    messages = _ref2$messages === void 0 ? [] : _ref2$messages,
    showLoader = _ref2.showLoader,
    icon = _ref2.icon,
    _ref2$autoCloseOnAcce = _ref2.autoCloseOnAccept,
    autoCloseOnAccept = _ref2$autoCloseOnAcce === void 0 ? false : _ref2$autoCloseOnAcce;
  if (!acceptText) {
    throw new Error('Accept text must be provided');
  }
  if (!title) {
    throw new Error('Title must be provided');
  }
  const dialog = useRef();
  const isOpen = useRef(false);
  const promiseRef = useRef();
  const open = useCallback(() => {
    let resolve;
    if (isOpen.current) {
      return promiseRef.current;
    }
    isOpen.current = true;
    promiseRef.current = new Promise(_resolve => {
      resolve = _resolve;
    });
    dialog.current = createDialog({
      title,
      declineText,
      acceptText,
      messages,
      showLoader,
      icon,
      autoCloseOnAccept
    }, resolve).open();
    return promiseRef.current;
  }, [title, declineText, acceptText, messages, showLoader, icon, autoCloseOnAccept]);
  const close = useCallback(() => {
    if (dialog.current instanceof ActualDialog) {
      isOpen.current = false;
      dialog.current.close();
    }
  }, []);
  return useMemo(() => ({
    open,
    close
  }), [open, close]);
};
setGlobal('svs.components.lbUi.betterDialog.useDialog', useDialog);

 })(window);